function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_729",
  "data-name": "Grupo 729",
  transform: "translate(-912.106 -147.461)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5344",
  "data-name": "Caminho 5344",
  d: "M938.148,153.744a2.007,2.007,0,1,0,2.007,2.007A2.007,2.007,0,0,0,938.148,153.744Zm-8.92,2.573a8.428,8.428,0,1,0,8.429,8.429A8.438,8.438,0,0,0,929.228,156.317Zm0,13.828a5.4,5.4,0,1,1,5.4-5.4A5.405,5.405,0,0,1,929.228,170.145Zm17.007-12.4a10.281,10.281,0,0,0-10.281-10.28H922.386a10.281,10.281,0,0,0-10.28,10.28V171.31a10.281,10.281,0,0,0,10.28,10.28h13.568a10.281,10.281,0,0,0,10.281-10.28Zm-3.22,13.569a7.06,7.06,0,0,1-7.061,7.06H922.386a7.06,7.06,0,0,1-7.06-7.06V157.741a7.06,7.06,0,0,1,7.06-7.06h13.568a7.06,7.06,0,0,1,7.061,7.06Z",
  fill: "#fff"
}));

var SvgIg = function SvgIg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.129,
    height: 34.129,
    viewBox: "0 0 34.129 34.129",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ig.2f1f7011.svg";
export { ForwardRef as ReactComponent };